import React from 'react'
import Provider from '@@/core/plugin-access/Provider'
const accessStrictMode = false;

export function accessProvider(element, {routes}){
    const props = {
            routes,
            accessStrictMode
        }
    return <Provider {...props}>{element}</Provider>
}
// generated at 2026/1/23 15:30:20 by sui v3.1.105